package one.healthium.onboarding.navigation.screenDefinition

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.arkivanov.decompose.extensions.compose.stack.Children
import one.healthium.onboarding.ui.components.dotRadius
import one.healthium.onboarding.ui.navigation.ScreenDefinitionResolver
import one.healthium.ui.compose.theme.AppTheme
import one.primehealth.analytics.compose.AppEventEffect
import one.primehealth.analytics.events.Events

@Composable
fun ScreenGroupContent(
    component: ScreenGroupComponent,
    modifier: Modifier = Modifier,
    onProgressBarShown: (Boolean) -> Unit,
) {
    Children(
        stack = component.stack,
        modifier = modifier,
    ) {
        val child = it.instance

        LaunchedEffect(child.screenDefinition.showProgressBar) {
            onProgressBarShown(child.screenDefinition.showProgressBar)
        }

        val screenId = child.screenDefinition.id
        AppEventEffect(screenId) {
            if (!screenId.isNullOrEmpty()) {
                logEvent(Events.OnboardingScreenViewed(screenId))
            }
        }

        Column(
            modifier = Modifier
                .fillMaxSize()
                .background(AppTheme.colors.windowBackground)
        ) {
            if (child.screenDefinition.showProgressBar) {
                Spacer(Modifier.height(7.dp + 27.dp + dotRadius.times(2)))
            }
            ScreenDefinitionResolver.resolve(
                screenDefinition = child.screenDefinition,
                eventDelegate = component,
            ).invoke()
        }
    }
}
